import React from 'react';
import clsx from 'clsx';
import './index.scss'; // 样式分离

export interface DbsTagProps {
  text: string | number; 
  type?: "default" | "warn"; // default: green colour and warn: red colour 
  icon?: React.ReactNode; // Optional icon to display before text
  backgroundColor?: string;
  textColor?: string;
  style?: React.CSSProperties; // Custom styles including borderRadius, padding, etc.
  className?: string; // Additional CSS class names
}

const DbsTag: React.FC<DbsTagProps> = ({
  text,
  type = 'default', // 预设样式类型
  icon,
  backgroundColor,
  textColor,
  style,
  className
}) => {
  // 合并自定义样式：style prop 优先级最高
  const tagStyle = {
    ...(backgroundColor && { backgroundColor }),
    ...(textColor && { color: textColor }),
    ...style
  };

  // 合并 className using clsx
  const tagClassName = clsx('dbs-tag', `dbs-tag--${type}`, className);

  return (
    <div
      className={tagClassName}
      style={tagStyle}
    >
      {icon && <span className="dbs-tag-icon">{icon}</span>}
      <span className="dbs-tag-text">{text}</span>
    </div>
  );
};

export default DbsTag;
